/*!
 * CBD HUT — Variant Picker UI helpers (Refresh/Dawn-safe)
 *
 * Purpose:
 * - Dropdown picker: keep the visible value + swatch preview in sync with the native <select>
 * - Radio/swatch picker: keep the legend “selected value” text in sync with the checked input
 *
 * Notes:
 * - This does NOT replace Shopify’s variant logic (variant-selects / variant-radios). It only updates UI text.
 * - Safe to run multiple times: per-root initialisation is idempotent.
 */

(function () {
  'use strict';

  function setText(el, text) {
    if (!el) return;
    el.textContent = (text || '').trim();
  }

  function updateFromSelect(select) {
    if (!select) return;

    var wrapper = select.closest('[data-cbh-select]');
    if (!wrapper) return;

    var overlay = wrapper.querySelector('[data-selected-value-text]');
    var opt = select.options && select.options[select.selectedIndex];

    if (overlay && opt) setText(overlay, opt.textContent);

    var swatch = wrapper.querySelector('.dropdown-swatch');
    if (swatch && opt) {
      var swVal = opt.getAttribute('data-option-swatch-value');
      var focal = opt.getAttribute('data-option-swatch-focal-point');

      if (swVal) {
        swatch.style.setProperty('--swatch-background', swVal);
        swatch.setAttribute('data-option-swatch-value', swVal);
      }

      if (focal) swatch.setAttribute('data-option-swatch-focal-point', focal);
    }
  }

  function initVariantSelects(root) {
    if (!root || root.dataset.cbhVariantUiInit === '1') return;
    root.dataset.cbhVariantUiInit = '1';

    function updateAll() {
      var selects = root.querySelectorAll('select[data-cbh-native-select]');
      for (var i = 0; i < selects.length; i++) updateFromSelect(selects[i]);
    }

    root.addEventListener(
      'change',
      function (e) {
        var t = e.target;
        if (t && t.matches && t.matches('select[data-cbh-native-select]')) updateFromSelect(t);
      },
      true
    );

    updateAll();
  }

  function updateLegends(root) {
    if (!root) return;

    var fieldsets = root.querySelectorAll('fieldset.cbh-variant-fieldset');
    for (var i = 0; i < fieldsets.length; i++) {
      var fs = fieldsets[i];
      var valEl = fs.querySelector('[data-selected-value]');
      if (!valEl) continue;

      var checked = fs.querySelector('input[type="radio"]:checked');
      if (!checked) continue;

      var label = fs.querySelector('label[for="' + checked.id + '"]');
      if (label) setText(valEl, label.textContent);
    }
  }

  function initVariantRadios(root) {
    if (!root || root.dataset.cbhVariantUiInit === '1') return;
    root.dataset.cbhVariantUiInit = '1';

    root.addEventListener(
      'change',
      function () {
        updateLegends(root);
      },
      true
    );

    updateLegends(root);
  }

  function initAll(context) {
    var scope = context && context.querySelectorAll ? context : document;

    var selectRoots = scope.querySelectorAll('variant-selects.cbh-variant-selects, .cbh-variant-selects');
    for (var i = 0; i < selectRoots.length; i++) initVariantSelects(selectRoots[i]);

    var radioRoots = scope.querySelectorAll('variant-radios.cbh-variant-radios, .cbh-variant-radios');
    for (var j = 0; j < radioRoots.length; j++) initVariantRadios(radioRoots[j]);
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  ready(function () {
    initAll(document);
  });

  // Theme editor + dynamic sections
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
  document.addEventListener('shopify:section:reorder', function (e) {
    initAll(e.target);
  });
  document.addEventListener('shopify:section:select', function (e) {
    initAll(e.target);
  });

  // Fallback for AJAX-inserted content (e.g., quick add)
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (!m.addedNodes || !m.addedNodes.length) continue;

        for (var n = 0; n < m.addedNodes.length; n++) {
          var node = m.addedNodes[n];
          if (!node || node.nodeType !== 1) continue;

          if (
            (node.matches &&
              node.matches('variant-selects.cbh-variant-selects, variant-radios.cbh-variant-radios, .cbh-variant-selects, .cbh-variant-radios')) ||
            (node.querySelector &&
              node.querySelector('variant-selects.cbh-variant-selects, variant-radios.cbh-variant-radios, .cbh-variant-selects, .cbh-variant-radios'))
          ) {
            initAll(node);
          }
        }
      }
    });

    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
